import { createAuth0 } from '@auth0/auth0-vue'

export const auth0 = createAuth0({
	domain: process.env.VUE_APP_TELEFLOW_AUTH_URL || 'dualtone.eu.auth0.com',
	clientId: process.env.VUE_APP_TELEFLOW_AUTH_CLIENT_ID || 'auRXkFqaEgSDyUKptIveHGAcr3Gsoxjh',
	authorizationParams: {
		redirect_uri: window.location.origin,
		audience: process?.env?.VUE_APP_TELEFLOW_AUTH_AUDIENCE || 'https://dev.teleflow.co.uk',
		scope: 'openid profile email'
	}
})
